export const isNew = (createdAt: string): boolean => {
  if (!createdAt) return false;
  const created = new Date(
    new Date(createdAt).toLocaleString("en-US", { timeZone: "Asia/Tokyo" }),
  );
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" }),
  );
  return (
    created.getFullYear() === now.getFullYear() &&
    created.getMonth() === now.getMonth() &&
    created.getDate() === now.getDate()
  );
};
